import { render } from "./SchedaVisualizzazioneHelp.vue?vue&type=template&id=46953634&scoped=true"
import script from "./SchedaVisualizzazioneHelp.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneHelp.vue?vue&type=script&lang=js"

import "./SchedaVisualizzazioneHelp.vue?vue&type=style&index=0&id=46953634&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46953634"]])

export default __exports__